
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { UIMixin } from '../../../mixins/uiMixin';
import PropTypes from 'prop-types';
import { finishLoading, ticketScan, cashoutedBets, toggleTimerInPopup, saveTimer, OpenPopup } from '../../../actions/ui';
import { addToBalance } from '../../../actions/terminal';
import Config from '../../../config/main';
import { sportTicketsColumnConfig, cashoutTicketsColumnConfig, casinoBetTicketsColumnConfig } from './constants/tableConfigs';
import { getTicketState, processBarcode, ticketHasTax } from '../../../helpers/tickets';
import { BetStateEnum } from '../../../constants/enums/betState';
import { broadcast, broadcastChannels } from '../../../helpers/broadcast';
import Helpers from '../../../helpers/helperFunctions';

const notCashoutableStates = [BetStateEnum.Accepted, BetStateEnum.Rejected, BetStateEnum.Lost];

class MultipleTicketsPopup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            errorMsg: null,
            expandedBarcode: null,
            checked: {},
            isLoading: false,
            ticketInBarcode: '',
            paiedTickets: null,
            earlyCashoutedBets: null,
            countdown: 60
        };
        this.earlyCashoutBets = this.earlyCashoutBets.bind(this);
        this.toggleTicket = this.toggleTicket.bind(this);
        this.toggleAllSportTickets = this.toggleAllSportTickets.bind(this);
        this.resetTimer = this.resetTimer.bind(this);
        this.setActiveClass = this.setActiveClass.bind(this);
        this.addToBalance = this.addToBalance.bind(this);
        this.barcodeNumberChange = this.barcodeNumberChange.bind(this);
        this.confirmBarcode = this.confirmBarcode.bind(this);
        this.timerWorkEnd = this.timerWorkEnd.bind(this);
        this.timerSecondChange = this.timerSecondChange.bind(this);
        this.createObjFromBackEnd = this.createObjFromBackEnd.bind(this);
        this.refreshPendingTickets = this.refreshPendingTickets.bind(this);
        this.refreshPendingTicketsDebounced = _.debounce(this.refreshPendingTickets, 800);

        this.ticketsColumnConfig = sportTicketsColumnConfig.bind(this);
        this.cashoutTicketsColumnConfig = cashoutTicketsColumnConfig.bind(this);
        this.casinoBetTicketsColumnConfig = casinoBetTicketsColumnConfig.bind(this);
        this.errorRemoveTimeout = null;
    }

    get sportTickets() {
        const { tickets } = this.props;
        const { checked } = this.state;
        const ticketsList = Object.values(tickets);

        return ticketsList.filter(item => !item.cashout).map(item => ({
            ...item,
            isChecked: !!checked[item.barcode],
            isActive: !notCashoutableStates.includes(getTicketState(item)),
        }));
    }

    get cashoutTickets() {
        const { tickets } = this.props;
        const { checked } = this.state;
        const ticketsList = Object.values(tickets);

        return ticketsList.filter(item => item.cashout).map(item => ({
            ...item,
            isChecked: !!checked[item.barcode],
            isActive: !notCashoutableStates.includes(getTicketState(item)),
        }));
    }

    createObjFromBackEnd(ticket) {
        const { tickets } = this.props;
        const { checked } = this.state;
        const paiedTickets = this.state.paiedTickets || {};

        if (!ticket.Succeeded) {
            ticket.Message && this.state.errorMsg !== ticket.Message && this.setState({ errorMsg: ticket.Message });
            return;
        }

        if (paiedTickets && !paiedTickets[ticket.Data] && tickets[ticket.Data]) {
            paiedTickets[ticket.Data] = {
                barcode: ticket.barcode || ticket.Data,
                message: ticket.Message,
                success: ticket.Succeeded,
            }

            if (ticket.Succeeded) {
                if (!checked[ticket.Data]) this.toggleTicket(tickets[ticket.Data]);
                checked[ticket.Data].enableRemoveCounter = true;
            }

            this.setState({ checked, paiedTickets });
        }
    }

    barcodeNumberChange(ticketInBarcode) {
        this.setState({ ticketInBarcode });
    }

    toggleAllSportTickets() {
        const activeTickets = this.sportTickets.filter(item => item.isActive);
        const allChecked = activeTickets.every(x => x.isChecked);
        const { checked } = this.state;

        activeTickets.forEach(item => {
            if (allChecked) delete checked[item.barcode];
            else if (!item.isChecked) this.toggleTicket(item);
        });

        allChecked && this.setState({ checked });
    }

    toggleAllCashoutTickets() {
        const activeTickets = this.cashoutTickets.filter(item => item.isActive);
        const allChecked = activeTickets.every(x => x.isChecked);
        const { checked } = this.state;

        activeTickets.forEach(item => {
            if (allChecked) delete checked[item.barcode];
            else if (!item.isChecked) this.toggleTicket(item);
        });

        allChecked && this.setState({ checked });
    }

    toggleTicket(ticket) {
        const { checked } = this.state;
        if (checked[ticket.barcode]) delete checked[ticket.barcode];
        else {
            let ticket_type;

            switch (true) {
                case ticket.sportBet:
                    ticket_type = 1;
                    break;
                case ticket.cashout:
                    ticket_type = 3;
                    break;
                default:
                    ticket_type = 2;
            }

            if (ticket_type === 2) {
                checked[ticket.barcode] = {
                    platform_transaction_id: ticket.dataFromSwarm.WinId,
                    barcode: ticket.barcode,
                    amount: ticket.dataFromSwarm.WinAmount,
                    ticket_type,
                    tax_amount: ticket.dataFromCasino.TaxAmountFromWin || 0
                };
            } else {
                checked[ticket.barcode] = {
                    barcode: ticket.barcode,
                    amount: ticket.amount || ticket.win_amount,
                    tax_amount: ticket.tax_amount || 0,
                    ticket_type,
                };
            }
        };

        this.setState({ checked });
    }

    get addToBalanceDisabled() {
        const { checked, paiedTickets } = this.state;

        if (_.isEmpty(checked)) return true;

        return paiedTickets && Object.keys(checked).every(item => paiedTickets[item]);
    }

    addToBalance() {
        const { checked, paiedTickets } = this.state;

        if (this.addToBalanceDisabled) return;

        this.setState({ isLoading: true });

        const checkedValues = Object.values(checked).filter(item => !item.enableRemoveCounter);

        const tickets = [...paiedTickets ? checkedValues.filter(item => !paiedTickets[item.barcode]) : checkedValues];

        const ticketsData = tickets.map(item => {
            const ticketInfo = this.props.tickets[item.barcode];
            // const taxAmount = ticketInfo.casinoTicket
            //         ? ticketInfo.dataFromCasino?.TotalTaxAmount
            //         : item.tax_amount;
            const Winamount = ticketInfo.casinoTicket ? ticketInfo.dataFromSwarm.WinAmount : ticketInfo?.win_amount;

            return {
                ...item,
                // tax_amount: taxAmount,
                with_credientals: !this.props.tickets[item.barcode]?.cashout && (Winamount > Config.minWinAmountToHandleIdentitionPopup),
                // with_credientals: !this.props.tickets[item.barcode]?.cashout && taxAmount !== 0 && ticketHasTax(ticketInfo),
                //!TODO: Which one ^??????
            };
        });
        if (Config.enableDmsValidationField && ticketsData.some(item => item.with_credientals)) {
            this.props.closePopup()();
            this.props.openPopup("dmsTicketIn", { tickets: ticketsData })();
        } else this.props.dispatch(addToBalance({
            tickets: ticketsData,
            user_data: {}
        }));
    }
    timerWorkEnd(second) {
        this.props.dispatch(saveTimer(second));

        if (second === 0) {
            this.props.dispatch(ticketScan(null, false));
            this.props.dispatch(cashoutedBets(null, false));
            this.props.closePopup()();
        }
    }
    earlyCashoutBets(barcode) {
        this.setState({ earlyCashoutedBets: { [barcode]: { cashoutedBarcodes: barcode }, ...this.state.earlyCashoutedBets } });
    }
    componentWillUnmount() {
        const { checked } = this.state;

        !_.isEmpty(checked) && Object.values(checked).forEach(item => {
            item.enableRemoveCounter && this.removeTicket(item.barcode);
        });

        if (this.errorRemoveTimeout) {
            clearTimeout(this.errorRemoveTimeout);
            this.errorRemoveTimeout = null;
        }

        broadcast.removeEventListener(broadcastChannels.PopupWrapperClick, this.resetTimer);
        this.props.dispatch(saveTimer(null));
        this.props.dispatch(cashoutedBets(this.state.earlyCashoutedBets, true));
    }
    timerSecondChange(second) {
        this.setState({ countdown: second });
    }
    setActiveClass(barcode) {
        const { expandedBarcode } = this.state;

        if (expandedBarcode !== barcode) this.setState({ expandedBarcode: barcode });
        else this.setState({ expandedBarcode: null });
    }
    componentDidMount() {
        broadcast.addEventListener(broadcastChannels.PopupWrapperClick, this.resetTimer);

        this.props.timer && this.props.dispatch(saveTimer(null));
        this.props.dispatch(toggleTimerInPopup(true));

        if (this.props.data && !this.props.data.error && this.props.data.barcode) {
            this.setState({ countdown: 60 });
            this.props.dispatch(ticketScan({ [this.props.data.barcode]: { ...this.props.data, scaned_at: Date.now() } }, true));

        } else if (this.props.ticketsList) {
            this.props.dispatch(ticketScan(this.props.ticketsList, true));
        }
        if (this.props.data && this.props.data.error) {
            this.setState({ errorMsg: this.props.data.errorText });
        }
    }
    componentDidUpdate(prevProps) {
        this.props.checkedTickets && this.createObjFromBackEnd(this.props.checkedTickets);

        const { checked } = this.state;
        const { tickets, cashoutTicket } = this.props;
        const errorText = this.props.data?.errorText;
        const prevErrorText = prevProps.data?.errorText;

        if (cashoutTicket && cashoutTicket !== prevProps.cashoutTicket) {
            const cashoutTicketData = typeof cashoutTicket.Data === 'object' && cashoutTicket.Data;
            if (cashoutTicketData) {
                const { Id, IsPaid } = cashoutTicketData;
                if (IsPaid && tickets[Id]) {
                    !checked[Id] && this.toggleTicket(tickets[Id]);
                    this.createObjFromBackEnd({
                        ...cashoutTicket,
                        Data: Id
                    });
                }
            }
        }

        if (this.props.data && this.props.data.barcode && prevProps.data && prevProps.data.barcode && prevProps.data.barcode !== this.props.data.barcode) {
            const existingTicket = tickets[this.props.data.barcode];
            const ticketData = { ...this.props.data, scaned_at: existingTicket?.scaned_at || Date.now() };

            this.props.dispatch(ticketScan({ [this.props.data.barcode]: ticketData }, true));
            this.setState({ errorMsg: null, countdown: 60 });
        }

        if (!prevProps.data?.barcode && this.props.data && this.props.data.barcode) {
            const existingTicket = tickets[this.props.data.barcode];
            const ticketData = { ...this.props.data, scaned_at: existingTicket?.scaned_at || Date.now() };

            this.setState({ errorMsg: null, countdown: 60 });
            return this.props.dispatch(ticketScan({ [this.props.data.barcode]: ticketData }, true));
        }

        if (this.props.data && !_.isEqual(this.props.data, prevProps.data) && this.props.data?.barcode === prevProps.data?.barcode) {
            const existingTicket = tickets[this.props.data.barcode];

            if (existingTicket) {
                const ticketData = { ...this.props.data, scaned_at: existingTicket.scaned_at || Date.now() };

                this.setState({ countdown: 60 });
                return this.props.dispatch(ticketScan({ [this.props.data.barcode]: ticketData }, true));
            }
        }

        if (prevProps.isFinished !== this.props.isFinished) {
            this.setState({ isLoading: false });
            this.props.dispatch(finishLoading(false));
        }

        if (errorText !== prevErrorText) this.setState({ errorMsg: errorText }, () => {
            this.errorRemoveTimeout = errorText && setTimeout(() => {
                this.errorRemoveTimeout = null;
                this.props.dispatch(OpenPopup('multipleTicketsPopup', { data: { error: false, errorText: '' } })); // Reseting the error
            }, 10000);
        });

        return false;
    }

    resetTimer() {
        const { tickets } = this.props;
        !_.isEmpty(tickets) && this.setState({ countdown: 60 });
    }

    onRefreshClick(e, barcode) {
        e.stopPropagation();
        this.refreshPendingTicketsDebounced(barcode);
    }

    confirmBarcode() {
        const { ticketInBarcode } = this.state;

        if (ticketInBarcode) {
            this.setState({ ticketInBarcode: '' });
            window.barcodeEnter(ticketInBarcode);
            window.barcodeBuffer = [];
        }
    }

    removeTicket(barcode) {
        const { checked } = this.state;
        delete checked[barcode];
        this.setState({ checked });
        this.props.dispatch(ticketScan(barcode, false));
    }

    async refreshPendingTickets(barcode) {
        const { tickets } = this.props;

        if (_.isEmpty(tickets)) return;

        processBarcode(barcode);
    }

    render() {
        // eslint-disable-next-line no-undef
        return Template.default.apply(this);
    }
}
MultipleTicketsPopup.propTypes = {
    data: PropTypes.object,
    tickets: PropTypes.object,
    errorText: PropTypes.string,
    openPopup: PropTypes.func,
    closePopup: PropTypes.func,
    isFinished: PropTypes.bool
};
const mapStateToProps = (state) => {
    return {
        tickets: state.uiState.tickets,
        checkedTickets: state.uiState.checkedTickets,
        cashoutTicket: state.uiState.cashoutTicket,
        isFinished: state.uiState.isFinished,
        earlyCashout: state.uiState.earlyCashout,
        timer: state.uiState.timer,
        token: state.terminal.authData.token
    };
};

export default connect(mapStateToProps)(UIMixin({ Component: MultipleTicketsPopup }));